module.exports = __webpack_public_path__ + "static/media/sort-arrows.3cc7514f.svg";